export const DNOTE_SERVICE_URL = 'https://dnote.office.lan';
